/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=6869a4c3"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6869a4c3&lang=less"

import exportComponent from "/Users/jiaohong/Documents/code/workSpace/kuaitandain-official-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__